import { roles } from '@/config/roles'

const routes = [
  {
    path: '/profession/:id',
    name: 'ProfessionView',
    component: () => import('@/views/profession/ProfessionView.vue'),
  },
  {
    path: '/profession/:id/direction',
    name: 'ProfessionDirection',
    component: () => import('@/views/profession/ProfessionDirection.vue'),
    props: true
  },
  {
    path: '/professions',
    name: 'ProfessionsList',
    component: () => import('@/views/profession/ProfessionsList.vue'),
  }
]
export default routes
